import { Calendar } from 'primereact/calendar';
import { useAttendanceTracker } from "../../Hooks/Features/employeeDashboard/useAttendanceTracker";
import { SkeletonContainer } from '../Loader/Loader.jsx';
import RegularizationRequest from "./RegularizationRequest.jsx";

const AttendanceTracker = ({ callApi, worklogDate, setWorklogDate }) => {
    const { date, setDate, loader, regularizationPopup, setRegularizationPopup, getMyAttendanceSummary, dateTemplate } = useAttendanceTracker({ callApi, worklogDate, setWorklogDate });

    return (
        <div className="w100 employee-dash-height">
            {loader ? <div style={{ height: "100%", width: "100%" }}><SkeletonContainer /></div> :
                <div className="attendance-card employee-dash-height w100 worklog-calendar">
                    <Calendar value={date} inline dateTemplate={dateTemplate} style={{ width: "100%" }}/>
                </div>
            }
            {regularizationPopup?.show && <RegularizationRequest regularization={regularizationPopup} handleClose={() => setRegularizationPopup({ show: false, data: null })} apiCall={getMyAttendanceSummary} />}
        </div>
    );
};

export default AttendanceTracker;
